import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import strings from "../utils/Strings";

const useReCaptchaBadge = () => {
  const location = useLocation(); // Get the current route

  useEffect(() => {

    const allowedRoutes = [
      "/",
      "/sign-up",
      "/forgot-password",
      "/reset-link",
      "/reset_password/user/:token",
    ];
    const styleId = "recaptcha-badge-style"; // Unique ID for the style tag
    if (process.env.REACT_APP_ENVIORNMENT === strings.environments.prod) {
      // Remove existing style tag if it exists
      const existingStyle = document.getElementById(styleId);
      if (existingStyle) {
        existingStyle.remove();
      }

      if (allowedRoutes.includes(location.pathname)) {
        const style = document.createElement("style");
        style.id = styleId; // Assign an ID for easy removal
        style.innerHTML = `
        .grecaptcha-badge {
          display: block !important;
          position: fixed !important;
          z-index: 9999 !important;
        }
      `;
        document.head.appendChild(style);
      }
      
    }
  }, [location.pathname]); // Runs when route changes
};

export default useReCaptchaBadge;
